export default "__VITE_ASSET__CdOqdbFq__"